import { useHistory } from "react-router-dom/cjs/react-router-dom";

const PlanDetails = () => {
  const history = useHistory();

  return (
    /* Locked to w-[428px] to replicate the mobile app view exactly. */
    <div className="w-[428px] mx-auto bg-[#f4f7ff] min-h-screen relative font-sans text-slate-900 pb-10 shadow-[0_0_50px_rgba(0,0,0,0.1)] overflow-x-hidden overflow-y-auto">
      {/* --- Top Blue Header --- */}
      <div
        className="absolute top-0 left-0 w-full h-[360px] bg-gradient-to-br from-[#0642cc] to-[#041a63] z-0 overflow-hidden bg-center bg-cover"
        style={{
          backgroundImage: "url('/img/new/background/mapchart.jpeg')",
        }}
      >
        {/* Back Button */}
        <div className="relative z-10 px-6 pt-12 pb-4">
          <button
            onClick={history.goBack}
            className="flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white px-3.5 py-1.5 rounded-xl font-medium text-[13px] transition-colors active:scale-95 backdrop-blur-sm"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            Back
          </button>
        </div>

        {/* Title & Description Area */}
        <div className="relative z-10 px-6 pt-2 max-w-[320px]">
          <h1 className="text-[28px] font-semibold text-white leading-tight mb-4 tracking-tight">
            About Our
            <br />
            Investment Plans
          </h1>
          <p className="text-[12px] text-blue-100 leading-relaxed font-medium mb-3">
            Africa's Trusted Digital Platform provides structured 7-day
            investment plans designed for clarity, transparency, and ease of
            use. Each plan follows a fixed investment cycle, allowing clients to
            clearly understand their expected returns before participating.
          </p>
          <p className="text-[12px] text-blue-100 leading-relaxed font-medium">
            All payouts consist of the initial capital plus calculated profit,
            released at the end of the investment cycle.
          </p>
        </div>
      </div>

      <div className="relative z-10 mt-[320px] flex flex-col gap-4">
        {/* --- Card 1: Growth Investment Plans --- */}
        <div className="bg-white rounded-[1.5rem] p-5 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-50">
          {/* Card Header */}
          <div className="flex items-center gap-3 mb-5 border-b border-gray-50 pb-4">
            <div className="w-9 h-9 bg-[#1a4bdf] rounded-xl flex items-center justify-center text-white shadow-md shadow-blue-600/20">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
            </div>
            <h3 className="text-[16px] font-semibold text-slate-900">
              Growth Investment Plans
            </h3>
          </div>

          {/* Top Stats Pill Row */}
          <div className="grid grid-cols-2 gap-3 mb-6">
            <div className="bg-[#f8faff] rounded-xl p-3 flex items-center gap-3 border border-[#dce5fc]">
              <div className="text-[#1a4bdf]">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div className="flex flex-col">
                <span className="text-[10px] text-slate-500 font-medium">
                  Investment Duration
                </span>
                <span className="text-[14px] font-semibold text-[#1a4bdf]">
                  7 Days
                </span>
              </div>
            </div>
            <div className="bg-[#f8faff] rounded-xl p-3 flex items-center gap-3 border border-[#dce5fc]">
              <div className="text-[#1a4bdf]">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  <polyline points="11 8 11 12 14 15"></polyline>
                </svg>
              </div>
              <div className="flex flex-col">
                <span className="text-[10px] text-slate-500 font-medium">
                  Projected Return
                </span>
                <span className="text-[14px] font-semibold text-[#1a4bdf]">
                  550%
                </span>
              </div>
            </div>
          </div>

          {/* Essential Growth Plan */}
          <div className="mb-6">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-[#1a4bdf] rounded-2xl flex items-center justify-center text-white shadow-md shadow-blue-600/20 shrink-0">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 2v4"></path>
                  <path d="M12 18v4"></path>
                  <path d="M4.93 4.93l2.83 2.83"></path>
                  <path d="M16.24 16.24l2.83 2.83"></path>
                  <path d="M2 12h4"></path>
                  <path d="M18 12h4"></path>
                  <path d="M4.93 19.07l2.83-2.83"></path>
                  <path d="M16.24 7.76l2.83-2.83"></path>
                </svg>
              </div>
              <div className="flex flex-col">
                <h4 className="text-[15px] font-semibold text-[#1a4bdf]">
                  Essential Growth Plan
                </h4>
                <span className="text-[11px] text-slate-500 font-medium">
                  (K3,000 - K10,000)
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-2 pl-[60px]">
              <div className="flex items-center justify-between text-[12px] font-medium border-b border-gray-50 pb-1.5">
                <div className="flex items-center gap-2 text-slate-600">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#1a4bdf]"></div>
                  Invest K3,000
                </div>
                <div className="text-gray-300">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
                <div className="text-[#1a4bdf] font-semibold">
                  Receive K19,500
                </div>
              </div>
              <div className="flex items-center justify-between text-[12px] font-medium border-b border-gray-50 pb-1.5">
                <div className="flex items-center gap-2 text-slate-600">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#1a4bdf]"></div>
                  Invest K5,000
                </div>
                <div className="text-gray-300">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
                <div className="text-[#1a4bdf] font-semibold">
                  Receive K32,500
                </div>
              </div>
              <div className="flex items-center justify-between text-[12px] font-medium border-b border-gray-50 pb-1.5">
                <div className="flex items-center gap-2 text-slate-600">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#1a4bdf]"></div>
                  Invest K7,000
                </div>
                <div className="text-gray-300">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
                <div className="text-[#1a4bdf] font-semibold">
                  Receive K45,500
                </div>
              </div>
              <div className="flex items-center justify-between text-[12px] font-medium pb-1.5">
                <div className="flex items-center gap-2 text-slate-600">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#1a4bdf]"></div>
                  Invest K10,000
                </div>
                <div className="text-gray-300">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
                <div className="text-[#1a4bdf] font-semibold">
                  Receive K65,000
                </div>
              </div>
            </div>
          </div>

          <div className="h-px w-full bg-gray-100 mb-6"></div>

          {/* Prestige Growth Plan */}
          <div>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-[#7c3aed] rounded-2xl flex items-center justify-center text-white shadow-md shadow-purple-600/20 shrink-0">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                </svg>
              </div>
              <div className="flex flex-col">
                <h4 className="text-[15px] font-semibold text-[#7c3aed]">
                  Prestige Growth Plan
                </h4>
                <span className="text-[11px] text-slate-500 font-medium">
                  (K11,000 - K20,000)
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-2 pl-[60px]">
              <div className="flex items-center justify-between text-[12px] font-medium border-b border-gray-50 pb-1.5">
                <div className="flex items-center gap-2 text-slate-600">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#7c3aed]"></div>
                  Invest K11,000
                </div>
                <div className="text-gray-300">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
                <div className="text-[#7c3aed] font-semibold">
                  Receive K71,500
                </div>
              </div>
              <div className="flex items-center justify-between text-[12px] font-medium border-b border-gray-50 pb-1.5">
                <div className="flex items-center gap-2 text-slate-600">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#7c3aed]"></div>
                  Invest K15,000
                </div>
                <div className="text-gray-300">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
                <div className="text-[#7c3aed] font-semibold">
                  Receive K97,500
                </div>
              </div>
              <div className="flex items-center justify-between text-[12px] font-medium border-b border-gray-50 pb-1.5">
                <div className="flex items-center gap-2 text-slate-600">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#7c3aed]"></div>
                  Invest K18,000
                </div>
                <div className="text-gray-300">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
                <div className="text-[#7c3aed] font-semibold">
                  Receive K117,000
                </div>
              </div>
              <div className="flex items-center justify-between text-[12px] font-medium pb-1.5">
                <div className="flex items-center gap-2 text-slate-600">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#7c3aed]"></div>
                  Invest K20,000
                </div>
                <div className="text-gray-300">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
                <div className="text-[#7c3aed] font-semibold">
                  Receive K130,000
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- Card 2: How It Works --- */}
        <div className="bg-white rounded-[1.5rem] p-5 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-50">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 bg-[#1a4bdf] rounded-xl flex items-center justify-center text-white shadow-md shadow-blue-600/20">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </div>
            <h3 className="text-[16px] font-semibold text-slate-900">
              How It Works
            </h3>
          </div>

          <div className="relative flex justify-between items-start pt-2 px-1">
            {/* Connecting Dashed Line */}
            <div className="absolute top-[32px] left-[10%] right-[10%] h-px border-t border-dashed border-blue-200 z-0"></div>

            {/* Step 1 */}
            <div className="flex flex-col items-center gap-2 z-10 w-[70px]">
              <div className="w-[18px] h-[18px] bg-[#f0f4ff] rounded-full text-[#1a4bdf] text-[10px] font-semibold flex items-center justify-center mb-1 border border-white">
                1
              </div>
              <div className="w-12 h-12 bg-white rounded-xl shadow-sm border border-[#dce5fc] flex items-center justify-center text-[#1a4bdf]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              <p className="text-[9px] text-center text-slate-500 font-medium leading-tight">
                Choose an investment amount
              </p>
            </div>

            {/* Step 2 */}
            <div className="flex flex-col items-center gap-2 z-10 w-[70px]">
              <div className="w-[18px] h-[18px] bg-[#f0f4ff] rounded-full text-[#1a4bdf] text-[10px] font-semibold flex items-center justify-center mb-1 border border-white">
                2
              </div>
              <div className="w-12 h-12 bg-white rounded-xl shadow-sm border border-[#dce5fc] flex items-center justify-center text-[#1a4bdf]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <p className="text-[9px] text-center text-slate-500 font-medium leading-tight">
                Complete the 7-day cycle
              </p>
            </div>

            {/* Step 3 */}
            <div className="flex flex-col items-center gap-2 z-10 w-[70px]">
              <div className="w-[18px] h-[18px] bg-[#f0f4ff] rounded-full text-[#1a4bdf] text-[10px] font-semibold flex items-center justify-center mb-1 border border-white">
                3
              </div>
              <div className="w-12 h-12 bg-white rounded-xl shadow-sm border border-[#dce5fc] flex items-center justify-center text-[#1a4bdf]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
                  <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
                  <path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path>
                </svg>
              </div>
              <p className="text-[9px] text-center text-slate-500 font-medium leading-tight">
                Receive your capital plus profit
              </p>
            </div>

            {/* Step 4 */}
            <div className="flex flex-col items-center gap-2 z-10 w-[70px]">
              <div className="w-[18px] h-[18px] bg-[#f0f4ff] rounded-full text-[#1a4bdf] text-[10px] font-semibold flex items-center justify-center mb-1 border border-white">
                4
              </div>
              <div className="w-12 h-12 bg-white rounded-xl shadow-sm border border-[#dce5fc] flex items-center justify-center text-[#1a4bdf]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </div>
              <p className="text-[9px] text-center text-slate-500 font-medium leading-tight">
                Withdraw or reinvest for a new cycle
              </p>
            </div>
          </div>
        </div>

        {/* --- Card 3: Key Information --- */}
        <div className="bg-white rounded-[1.5rem] p-5 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-50 flex flex-col gap-5">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-9 h-9 bg-[#1a4bdf] rounded-xl flex items-center justify-center text-white shadow-md shadow-blue-600/20">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
            </div>
            <h3 className="text-[16px] font-semibold text-slate-900">
              Key Information
            </h3>
          </div>

          <div className="grid grid-cols-2 gap-y-5 gap-x-2">
            {/* Item 1 */}
            <div className="flex items-start gap-2">
              <div className="mt-0.5 text-[#1a4bdf]">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <div className="flex flex-col">
                <span className="text-[10px] text-slate-500 font-medium">
                  Minimum deposit:
                </span>
                <span className="text-[13px] font-semibold text-[#1a4bdf]">
                  $150.80
                </span>
              </div>
            </div>
            {/* Item 2 */}
            <div className="flex items-start gap-2">
              <div className="mt-0.5 text-[#1a4bdf]">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="6" width="20" height="12" rx="2"></rect>
                  <circle cx="12" cy="12" r="2"></circle>
                  <path d="M6 12h.01M18 12h.01"></path>
                </svg>
              </div>
              <div className="flex flex-col">
                <span className="text-[10px] text-slate-500 font-medium">
                  Minimum withdrawal:
                </span>
                <span className="text-[13px] font-semibold text-[#1a4bdf]">
                  $1,000
                </span>
              </div>
            </div>
            {/* Item 3 */}
            <div className="flex items-start gap-2">
              <div className="mt-0.5 text-[#1a4bdf]">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect
                    x="3"
                    y="11"
                    width="18"
                    height="11"
                    rx="2"
                    ry="2"
                  ></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
              </div>
              <div className="flex flex-col">
                <span className="text-[10px] text-slate-500 font-medium">
                  Withdrawal processing:
                </span>
                <span className="text-[13px] font-semibold text-[#1a4bdf]">
                  Up to 30 minutes
                </span>
              </div>
            </div>
            {/* Item 4 */}
            <div className="flex items-start gap-2">
              <div className="mt-0.5 text-[#1a4bdf]">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div className="flex flex-col">
                <span className="text-[10px] text-slate-500 font-medium">
                  Investment cycle:
                </span>
                <span className="text-[13px] font-semibold text-[#1a4bdf]">
                  7 days
                </span>
              </div>
            </div>
            {/* Item 5 */}
            <div className="flex items-start gap-2 col-span-2">
              <div className="mt-0.5 text-[#1a4bdf]">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                </svg>
              </div>
              <div className="flex flex-col">
                <span className="text-[10px] text-slate-500 font-medium">
                  Support:
                </span>
                <span className="text-[13px] font-semibold text-[#1a4bdf]">
                  24/7 WhatsApp
                </span>
              </div>
            </div>
          </div>

          <div className="bg-[#f4f7ff] rounded-xl p-3 border border-[#dce5fc] flex items-center gap-3">
            <div className="w-5 h-5 rounded-full bg-[#1a4bdf] flex items-center justify-center text-white shrink-0 shadow-sm">
              <span className="text-[12px] font-semibold font-serif italic">
                i
              </span>
            </div>
            <p className="text-[11px] text-slate-600 font-medium leading-snug flex-1">
              Our support team assists clients step by step to ensure accounts
              are properly activated and monitored throughout the investment
              period.
            </p>
            <div className="w-12 rounded-full shrink-0 flex justify-end">
              <img
                src="/img/new/background/shieldandwhatsapp.jpeg"
                alt="Headset"
                className="w-full object-contain rounded-full "
              />
            </div>
          </div>
        </div>

        {/* --- Card 4: Transparency & Support --- */}
        <div className="bg-white rounded-[1.5rem] p-5 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-50 flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors">
          <div className="flex items-center gap-4 pr-4">
            <div className="w-10 h-10 bg-[#1a4bdf] rounded-xl flex items-center justify-center text-white shadow-md shadow-blue-600/20 shrink-0">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
              </svg>
            </div>
            <div className="flex flex-col">
              <h3 className="text-[15px] font-semibold text-slate-900 mb-1">
                Transparency & Support
              </h3>
              <p className="text-[10px] text-slate-500 font-medium leading-relaxed">
                Africa's Trusted Digital Platform is committed to clear
                communication, timely processing, and professional client
                support. All investment details are presented upfront so clients
                can make informed decisions with confidence.
              </p>
            </div>
          </div>
          <div className="text-slate-400 shrink-0">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanDetails;
